<section class="analytics-panel">
    <div class="analytics-toolbar">
        <div class="analytics-title">
            <h3 class="m-0 f-s-16 f-w-600">Activity KPIs</h3>
            <div class="analytics-meta">
                <span class="privacy-chip">
                    <mat-icon>visibility_off</mat-icon>
                    Masked identities
                </span>
                @if (generatedAtLabel) {
                    <span class="text-gray-100 f-s-12">Updated {{ generatedAtLabel }}</span>
                }
            </div>
        </div>
        <span class="spacer"></span>
        <button
                (click)="refresh.emit()"
                [disabled]="!selectedWebinar || isLoading"
                aria-label="Refresh analytics"
                class="d-inline-flex align-items-center gap-6"
                color="primary"
                mat-stroked-button
                type="button"
        >
            <mat-icon>refresh</mat-icon>
            <span>Refresh</span>
        </button>
    </div>

    @if (!selectedWebinar) {
        <div class="analytics-empty">
            <mat-icon color="accent">insights</mat-icon>
            <p class="m-0 text-gray-100">Save the webinar to collect analytics.</p>
        </div>
    } @else if (isLoading) {
        <div class="analytics-loading">
            <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
        </div>
    } @else if (errorMessage) {
        <div class="analytics-error">
            <mat-icon>error_outline</mat-icon>
            <div class="d-flex flex-col gap-4">
                <span class="f-s-14 f-w-600">Could not load analytics</span>
                <span class="f-s-13">{{ errorMessage }}</span>
            </div>
        </div>
    } @else if (analytics && summary) {
        <div class="analytics-kpi-grid">
            @for (kpi of kpis; track kpi.label) {
                <div class="analytics-kpi">
                    <span class="analytics-kpi__label">{{ kpi.label }}</span>
                    <strong class="analytics-kpi__value">{{ kpi.value }}</strong>
                    <span class="analytics-kpi__hint">{{ kpi.hint }}</span>
                </div>
            }
        </div>

        @if (!hasActivity) {
            <div class="analytics-empty compact">
                <mat-icon color="accent">query_stats</mat-icon>
                <p class="m-0 text-gray-100">No attendee activity yet.</p>
            </div>
        }

        <div class="analytics-table-section">
            <div class="section-header">
                <h3 class="m-0 f-s-16 f-w-600">Participant metrics</h3>
                <p class="m-0 text-gray-100 f-s-14 section-lead">
                    Names and email addresses are hidden in this view.
                </p>
            </div>

            @if (users.length) {
                <div class="table-responsive">
                    <table [dataSource]="users" class="webinars-table analytics-users-table" mat-table>
                        <ng-container matColumnDef="attendee">
                            <th *matHeaderCellDef mat-header-cell>Participant</th>
                            <td *matCellDef="let user; let i = index" mat-cell>{{ attendeeLabel(i) }}</td>
                        </ng-container>

                        <ng-container matColumnDef="registered">
                            <th *matHeaderCellDef mat-header-cell>Registered</th>
                            <td *matCellDef="let user" mat-cell>{{ formatBool(user.registered) }}</td>
                        </ng-container>

                        <ng-container matColumnDef="attended">
                            <th *matHeaderCellDef mat-header-cell>Attended</th>
                            <td *matCellDef="let user" mat-cell>{{ formatBool(user.attended) }}</td>
                        </ng-container>

                        <ng-container matColumnDef="watchTime">
                            <th *matHeaderCellDef mat-header-cell>Watch time</th>
                            <td *matCellDef="let user" mat-cell>{{ formatDuration(user.totalDurationSeconds) }}</td>
                        </ng-container>

                        <ng-container matColumnDef="completion">
                            <th *matHeaderCellDef mat-header-cell>Completion</th>
                            <td *matCellDef="let user" mat-cell>{{ formatPercent(user.attendancePercent) }}</td>
                        </ng-container>

                        <ng-container matColumnDef="engagement">
                            <th *matHeaderCellDef mat-header-cell>Engagement</th>
                            <td *matCellDef="let user" mat-cell>{{ user.engagementScore }}</td>
                        </ng-container>

                        <tr *matHeaderRowDef="userColumns" mat-header-row></tr>
                        <tr *matRowDef="let row; columns: userColumns" mat-row></tr>
                    </table>
                </div>
            } @else {
                <div class="analytics-empty compact">
                    <mat-icon color="accent">person_off</mat-icon>
                    <p class="m-0 text-gray-100">No participant rows returned.</p>
                </div>
            }
        </div>
    } @else {
        <div class="analytics-empty">
            <mat-icon color="accent">insights</mat-icon>
            <p class="m-0 text-gray-100">No analytics available yet.</p>
        </div>
    }
</section>
